import React from "react";
import BaseCard from "../../../components/ui/BaseCard";

// Same rules the change-password form validates against.
const rules = [
  {
    text: "Password must be at least 8 characters long",
    isMet: (password) => password?.length >= 8,
  },
  {
    text: "Must Have Uppercase Characters.",
    isMet: (password) => /[A-Z]/.test(password),
  },
  {
    text: "Must Have Lowercase Characters.",
    isMet: (password) => /[a-z]/.test(password),
  },
  {
    text: "Must Have Numaric Characters.",
    isMet: (password) => /[0-9]/.test(password),
  },
  {
    text: "Must Have Symbol Characters.",
    isMet: (password) => /[@$!%*?&]/.test(password),
  },
];

const PasswordPolicy = ({ password = "" }) => {
  return (
    <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
      <div className="bg-light px-4 py-2 mt-2 mb-2 rounded-md flex justify-between items-center">
        <div className="flex items-center">
          <i className="fa-solid fa-circle-info text-base mr-2"></i>
          <h6 className="text-dark font-normal">Password Policy</h6>
        </div>
      </div>
      <ul className="px-4 py-3">
        {rules.map((rule) => {
          const passed = password ? rule.isMet(password) : false;

          return (
            <li key={rule.text} className="flex items-center mb-1">
              {passed ? (
                <i className="text-xs fa-solid fa-check text-primary bg-[#D8EBF8] rounded-full flex items-center justify-center min-h-[18px] min-w-[18px]"></i>
              ) : (
                <i className="text-primary border-2 border-[#D8EBF8] rounded-full flex items-center justify-center min-h-[18px] min-w-[18px]"></i>
              )}
              <p
                className={`ml-3 text-[13px] font-300 ${
                  passed ? "text-primary" : "text-[#525354]"
                }`}
              >
                {rule.text}
              </p>
            </li>
          );
        })}
      </ul>
    </BaseCard>
  );
};

export default PasswordPolicy;
